module.exports = __webpack_public_path__ + "static/media/paper28.80c866c5.jpg";